
























import { Mixins, Component, Provide, Prop } from "vue-property-decorator"
import PageMixin from "@/mixins/page"
import { Columns, VERSION_STATUS } from "./constant"
import { pick } from "lodash"
import { mapGetters } from "vuex"
import manageService from "@/services/manage.service"
import config from "@/config"
import commonService from "@/services/common.service"
import { debounce } from "@/decorators"

interface Product {
    software_id: number
    product_id: number
    product_name: string
    product_type: number
    product_sub_type: number
}
@Component({
    name: "ItemTable",
    computed: {
        ...mapGetters(["currentUser"]),
        ...mapGetters("common", ["product_type"])
    }
})
export default class ItemTable extends Mixins(PageMixin) {
    readonly currentUser: any
    readonly product_type: any
    loading = false
    dataSource: any[] = []
    pagination = {
        current: 1,
        pageSize: 20,
        showQuickJumper: false,
        showSizeChanger: true,
        total: 0
    }

    userRoles: { system_roles: any[] } = { system_roles: [] }

    @Prop({ default: 1, type: Number })
    currentKey: number

    @Prop({ type: Number })
    currentProductId: number

    @Prop({ type: Array })
    currentProductList: []

    @Prop({ type: Number })
    software_id: number

    @Prop({ type: Array })
    product_list: Product[]

    created() {
        this.getUserRoles()
    }

    async getUserRoles() {
        try {
            const res = await commonService.getUserRoles({
                user_id: this.currentUser.uid
            })
            this.userRoles = res || {}
        } catch (error) {
            this.$message.error(`获取权限失败！${error}`)
        }
    }

    @Provide()
    get useWrapperContext() {
        return this
    }

    get columns() {
        const cols: any = [
            {
                title: "版本名称",
                dataIndex: "version_name",
                key: "version_name",
                width: 200,
                filter: {
                    type: "input"
                },
                scopedSlots: { customRender: "version_name" }
            }
        ]
        return [...cols, ...Columns]
    }

    get tableActions() {
        return (record: any) => {
            const actions = {
                lock: {
                    title: "锁版",
                    event: "lock"
                },
                release: {
                    title: "发布",
                    event: "release"
                },
                viewApply: {
                    title: "查看审批流程",
                    event: "viewApply"
                },
                suspend: {
                    title: "暂停发布",
                    event: "suspend"
                },
                schedule: {
                    title: "调整排期",
                    event: "schedule"
                },
                recovery: {
                    title: "恢复发布",
                    event: "recovery"
                },
                edit: {
                    title: "编辑",
                    event: "edit"
                }
            }
            const {
                is_lock_version_user,
                is_release_people,
                is_scheduling_user,
                is_show_suspend_btn,
                approval_id,
                version_status
            } = record
            const actionsTypes = []
            if (approval_id) {
                actionsTypes.push("viewApply")
            }
            if (is_release_people && version_status === VERSION_STATUS.已经锁版) {
                actionsTypes.push("release")
            }
            if (is_lock_version_user && version_status === VERSION_STATUS.未锁版) {
                actionsTypes.push("lock")
            }
            if (is_show_suspend_btn && is_release_people) {
                actionsTypes.push("suspend")
            }
            if (is_scheduling_user && version_status === VERSION_STATUS.未锁版) {
                actionsTypes.push("schedule")
            }
            if (is_release_people && version_status === VERSION_STATUS.暂停发布) {
                actionsTypes.push("recovery")
            }
            if (this.userRoles.system_roles.includes("admin")) {
                actionsTypes.push("edit")
            }
            const filteredActions = pick(actions, actionsTypes)
            return Object.values(filteredActions)
        }
    }

    onLock(records: any[]) {
        const record = records[0]
        this.$router.push({
            path: "/manage/version-lock",
            query: {
                id: String(record.product_version_id)
            }
        })
    }

    onRelease(records: any[]) {
        const record = records[0]
        this.$router.push({
            path: "/manage/version-release",
            query: {
                id: String(record.product_version_id)
            }
        })
    }

    onView(record: any) {
        this.$router.push({
            path: "/manage/version-detail",
            query: {
                id: String(record.product_version_id)
            }
        })
    }

    onSuspend(records: any) {
        const record = records[0]
        this.$router.push({
            path: "/manage/version-suspend",
            query: {
                id: String(record.product_version_id)
            }
        })
    }

    onSchedule(records: any) {
        const record = records[0]
        this.$router.push({
            path: "/manage/version-schedule",
            query: {
                id: String(record.product_version_id)
            }
        })
    }

    activated() {
        this.refreshList()
    }

    @debounce(200)
    refreshList() {
        ;(this.$refs.table as any).onSearch()
    }

    onRecovery(records: any[]) {
        const record = records[0]
        this.$router.push({
            path: "/manage/version-suspend",
            query: {
                id: String(record.product_version_id)
            }
        })
    }

    onEdit(records: any[]) {
        const record = records[0]
        this.$router.push({
            path: "/manage/version-edit",
            query: {
                id: String(record.product_version_id)
            }
        })
    }

    onViewApply(records: any) {
        const { approval_id } = records[0] || {}
        if (!approval_id) {
            return
        }
        const url =
            config.env === "online"
                ? `https://home.intsig.net/process-centric/approval-detail?approval_id=${approval_id}`
                : `https://home-sandbox.intsig.net/process-centric/approval-detail?approval_id=${approval_id}`
        // window.location.href = url
        window.open(url)
    }

    async changeProduct() {
        this.pagination.current = 1
    }

    async onSearch(
        keyword: string,
        pagination: any,
        sorts: any[],
        filters?: any[]
    ): Promise<{ total: number; list: any[] }> {
        if (!this.software_id || !this.currentProductId) {
            return {
                list: [],
                total: 0
            }
        }
        Object.assign(this, { pagination, sorts, filters })
        const offset = (this.pagination.current - 1) * this.pagination.pageSize
        const limit = this.pagination.pageSize
        const payload: any = {
            offset,
            limit,
            software_id: this.software_id,
            product_type: this.product_list.find(
                (item: { product_id: any }) => item.product_id === this.currentProductId
            )?.product_type,
            product_id: this.currentProductId
        }

        if (sorts && sorts.length) {
            sorts.forEach(item => {
                if (item.dataIndex === "latest_release_time") {
                    payload.release_time_sort = item.is_ascend ? 2 : 1
                } else {
                    payload[`${item.dataIndex}_sort`] = item.is_ascend ? 2 : 1
                }
            })
        }
        if (filters && filters.length) {
            filters.forEach(item => {
                if (item.dataIndex === "lock_time") {
                    payload.lock_time_start = item.keyword[0] || ""
                    payload.lock_time_end = item.keyword[1] || ""
                } else if (item.dataIndex === "latest_release_time") {
                    payload.release_time_start = item.keyword[0] || ""
                    payload.release_time_end = item.keyword[1] || ""
                } else {
                    payload[item.dataIndex] = item.keyword
                }
            })
        }
        this.loading = true
        try {
            const res = await manageService.getVersionList(payload)
            const { list, total } = res
            this.dataSource = list || []
            return {
                list,
                total
            }
        } catch (error) {
            if (error) {
                this.$message.error(`获取数据失败！ ${error}`)
            }
        } finally {
            this.loading = false
        }
    }
}
